import {
    ragService
} from 'shared/api/services/PROJECT-O';

class AILabHelper {

    // Process Multiplee AI Lab Docs
    // This will put all the files in promise first, and assign the correct name metadata, hence a helper function
    async ProcessFiles(files, filter, org, suborg, bucket, chunk_size = 200, chunk_overlap = 20) {

        try {
            const results = await Promise.all(files.map(async (file, index) => {
                const form = new FormData();

                form.append('organization_id', org);
                form.append('sub_organization_id', suborg);
                form.append('bucket_name', bucket);
                form.append('chunk_size', chunk_size);
                form.append('chunk_overlap', chunk_overlap);

                // Make sure the extension is lowercased
                const newFile = this.toLowerCaseExtension(file);
                form.append('files', newFile);

                let filter2 = {
                    ...filter
                };
                filter2.name = newFile.name;

                form.append('metadata', JSON.stringify(filter2));

                try {
                    const res = await ragService.processFile(form);

                    if (!res.data || res.data.document_ids.length === 0) {
                        console.error(`No document IDs received for file at index ${index}.`);
                        return null;
                    }

                    return res.data;
                } catch (error) {
                    console.error(`Error processing file at index ${index}:`, error);
                    return null;
                }
            }));

            return results.filter(result => result !== null && result !== undefined);
        } catch (error) {

            return [];
        }
    }

    constructRetrievedResults(docs) {
        //
        let str = '';
        docs.forEach((doc) => {
            let ext = this.getFileExtension(doc.metadata.name);
            let ppt = ext === 'ppt' || ext === 'pptx' || ext === 'PPT' || ext === 'PPTX';
            let pdf = ext === 'pdf' || ext === 'PDF';
            let docx = ext === 'docx' || ext === 'DOCX';

            str += '[Document]\n';
            str += ppt ? `[Page]${doc.metadata.slide_number}[/Page]\n` : '';
            str += (pdf || docx) ? `[Page]${doc.metadata.start_page} to ${doc.metadata.end_page}[/Page]\n` : '';
            str += `[Title]${doc.metadata.name}[/Title]\n`;
            str += `[Content]${doc.page_content}[/Content]\n`;
            // str += ppt ? `[Page ${doc.metadata.slide_number}]\n` : "";
            str += '[/Document]\n\n';
        });
        return str;
    }

    getFileExtension(url) {
        // eslint-disable-next-line no-useless-escape
        return url.split('.').pop().split(/\#|\?/)[0];
    }

    toLowerCaseExtension(file) {
        const {
            name, type
        } = file;
        const lastDotIndex = name.lastIndexOf('.');
        if (lastDotIndex === -1) return file;
        const newFileName = `${name.slice(0, lastDotIndex)}.${name.slice(lastDotIndex + 1).toLowerCase()}`;

        // eslint-disable-next-line no-undef
        return new File([file], newFileName, {
            type
        });
    }

    // WatsonX
    ConstructPromptWatsonX(prompt) {
        let constructedPrompt = '';
        constructedPrompt =
        'Input:\n' +
        ((prompt.instruction) ? `Instruction:\n${prompt.instruction}\n\n` : '') +
        ((prompt.context) ? `Context:\n${prompt.context}\n\n` : '') +
        ((prompt.target_format) ? `Target Format:\n${prompt.target_format}\n\n` : '') +
        ((prompt.sample_input) ? `Sample Input:\n${prompt.sample_input}\n\n` : '') +
        ((prompt.sample_output) ? `Sample Output:\n${prompt.sample_output}\n\n` : '') +
        ((prompt.input_data) ? `Actual Input:\n${prompt.input_data}\n\n` : '')

        + 'Output:\n';
        return constructedPrompt;
    }
    ConstructPromptUnified(prompt) {
        let constructedPrompt = '';
        constructedPrompt =
        ((prompt.instruction) ? `## Instruction\n${prompt.instruction}` : '') +
        ((prompt.context) ? `\n\n## Context\n${prompt.context}` : '') +
        ((prompt.target_format) ? `\n\n## Target Format\n${prompt.target_format}` : '') +
        ((prompt.sample_input) ? `\n\n## Sample Input\n${prompt.sample_input}` : '') +
        ((prompt.sample_output) ? `\n\n## Sample Output\n${prompt.sample_output}` : '') +
        ((prompt.input_data) ? `\n\n## Actual Input\n${prompt.input_data}` : '');
        return constructedPrompt;
    }

    // Generate a structured template for instruction input
    GenerateInstructionTemplate() {
        return `## Instruction
[Provide the main instruction or task for the model]

## Context
[Add any relevant background information or context]

## Target Format
[Specify the desired output format or structure]

## Sample Input
[Provide an example input]

## Sample Output
[Show the expected output for the sample input]`;
    }

    // Parse a structured prompt back into sections
    // Returns an object with instruction, context, target_format, sample_input, sample_output
    ParseStructuredPrompt(promptText) {
        if (!promptText || typeof promptText !== 'string') {
            return {
                instruction: '',
                context: '',
                target_format: '',
                sample_input: '',
                sample_output: ''
            };
        }

        const sections = {
            instruction: '',
            context: '',
            target_format: '',
            sample_input: '',
            sample_output: ''
        };

        // Define section markers
        const sectionMarkers = [
            {
                key: 'instruction',
                markers: ['## Instruction', '##Instruction']
            },
            {
                key: 'context',
                markers: ['## Context', '##Context']
            },
            {
                key: 'target_format',
                markers: ['## Target Format', '##Target Format', '## TargetFormat', '##TargetFormat']
            },
            {
                key: 'sample_input',
                markers: ['## Sample Input', '##Sample Input', '## SampleInput', '##SampleInput']
            },
            {
                key: 'sample_output',
                markers: ['## Sample Output', '##Sample Output', '## SampleOutput', '##SampleOutput']
            }
        ];

        // Split into lines for processing
        const lines = promptText.split('\n');
        let currentSection = null;
        let currentContent = [];

        for (let i = 0; i < lines.length; i++) {
            const line = lines[i];
            const trimmedLine = line.trim();

            // Check if this line is a section header
            let foundSection = false;
            for (const section of sectionMarkers) {
                if (section.markers.some(marker => trimmedLine.startsWith(marker))) {
                    // Save previous section content
                    if (currentSection) {
                        sections[currentSection] = currentContent.join('\n').trim();
                    }
                    // Start new section
                    currentSection = section.key;
                    currentContent = [];
                    foundSection = true;
                    break;
                }
            }

            // If not a section header and we're in a section, add to content
            if (!foundSection && currentSection) {
                currentContent.push(line);
            }
            // If no section has been found yet, assume it's the instruction
            else if (!foundSection && !currentSection) {
                if (!sections.instruction) {
                    currentSection = 'instruction';
                }
                currentContent.push(line);
            }
        }

        // Save the last section
        if (currentSection) {
            sections[currentSection] = currentContent.join('\n').trim();
        }

        // Clean up placeholder text if it exists
        const placeholderPatterns = [
            /^\[.*\]$/,
            /^\(.*\)$/
        ];

        for (const key in sections) {
            const value = sections[key].trim();
            if (placeholderPatterns.some(pattern => pattern.test(value))) {
                sections[key] = '';
            }
        }

        return sections;
    }

    // Groq
    ConstructPromptGroq(prompt) {
        let constructedPrompt = '';
        constructedPrompt =
        'Input:\n' +
        ((prompt.instruction) ? `${prompt.instruction}\n\n` : '') +
        ((prompt.context) ? `${prompt.context}\n\n` : '') +
        ((prompt.target_format) ? `${prompt.target_format}\n\n` : '') +
        ((prompt.sample_input) ? `Sample Input:\n${prompt.sample_input}\n\n` : '') +
        ((prompt.sample_output) ? `Sample Output:\n${prompt.sample_output}\n\n` : '') +
        ((prompt.input_data) ? `Actual Input:\n${prompt.input_data}\n\n` : '')

        + 'Output:\n';
        return constructedPrompt;
    }

    //watsonX and Groq
    validateUniqueName = (uniqueName) => {
        if (!uniqueName) return {
            isValid: false,
            message: 'Unique Name field cannot be empty.'
        };
        if (/\s/.test(uniqueName)) return {
            isValid: false,
            message: 'Unique Name cannot contain spaces.'
        };
        if (uniqueName.length < 4) return {
            isValid: false,
            message: 'Unique Name should be at least 4 characters long.'
        };
        return {
            isValid: true,
            message: 'Valid Unique Name.'
        };
    };

    validateContextKey = (contextKey) => {
        if (/\s/.test(contextKey)) return {
            isValid: false,
            message: 'Context Key cannot contain spaces.'
        };
        if (contextKey.length < 4) return {
            isValid: false,
            message: 'Context Key should be at least 4 characters long.'
        };
        return {
            isValid: true,
            message: 'Valid Context Key.'
        };
    };

    //watsonX and Groq
    // extractValues = (inputString) => {
    //     // Regular expression to match the labels and capture values between them
    //     const labels = ["Instruction:", "Context:", "Target Format:", "Sample Input:", "Sample Output:"];
    //     const pattern = new RegExp(
    //       `(${labels.join('|')})\\s*(.*?)(?=(?:${labels.join('|')})|\\s*$)`,
    //       'gs'
    //     );

    //     const result = {};
    //     let match;

    //     // Find all matches using regular expression
    //     while ((match = pattern.exec(inputString)) !== null) {
    //       const label = match[1].trim();
    //       const value = match[2].trim();

    //       result[label] = value;
    //     }

    //     return result;
    // }

    formatToTitleCase = (str) => {
        return str
            .replace(/_/g, ' ') // Replace underscores with spaces
            .replace(/\w\S*/g, function(word) {
                return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            }); // Convert to Title Case
    };

    //watsonX and Groq
    extractValues(inputString) {
        // Define labels to look for
        const labels = ['Instruction:', 'Context:', 'Target Format:', 'Sample Input:', 'Sample Output:'];
        const markdownLabels = labels.map(label => `## ${label.replace(':', '')}`); // Markdown labels do not have a colon

        // Convert the input string into lines for precise processing
        const lines = inputString.split('\n');

        const result = {};
        let currentLabel = null;
        let currentValue = [];
        let foundMarkdownLabel = false;

        for (const line of lines) {
            const trimmedLine = line.trim();

            // Check for markdown labels first
            if (markdownLabels.includes(trimmedLine)) {
                foundMarkdownLabel = true;
                if (currentLabel) {
                    result[currentLabel] = currentValue.join('\n').trim();
                }
                currentLabel = trimmedLine;
                currentValue = [];
            }
            // Only check for normal labels if no markdown labels have been found
            else if (!foundMarkdownLabel && labels.includes(trimmedLine)) {
                if (currentLabel) {
                    result[currentLabel] = currentValue.join('\n').trim();
                }
                currentLabel = trimmedLine;
                currentValue = [];
            } else if (currentLabel) {
                // Continue accumulating value for the current label
                currentValue.push(line);
            }
        }

        // Save the last extracted section
        if (currentLabel) {
            result[currentLabel] = currentValue.join('\n').trim();
        }

        return result;
    }

}
const labHelper = new AILabHelper();
export default labHelper;